const keysSelect = [
    "fonts",
    "domBlockers",
    "fontPreferences",
    "audio",
    "screenFrame",
    "canvas",
    "osCpu",
    "languages",
    "colorDepth",
    "deviceMemory",
    "screenResolution",
    "hardwareConcurrency",
    "timezone",
    "sessionStorage",
    "localStorage",
    "indexedDB",
    // 'openDatabase',
    "cpuClass",
    "platform",
    "plugins",
    "touchSupport",
    "vendor",
    "vendorFlavors",
    "cookiesEnabled",
    "colorGamut",
    "invertedColors",
    "forcedColors",
    "monochrome",
    "contrast",
    "reducedMotion",
    "reducedTransparency",
    "hdr",
    "math",
    "pdfViewerEnabled",
    "architecture",
    "applePay",
    "privateClickMeasurement",
    "audioBaseLatency",
    "webGlBasics",
    "webGlExtensions",
];

async function getHashFromObject(object: Record<string, any>): Promise<string> {
    {
        const keys = Object.keys(object);
        const filteredValues = keys.map((key: any) => {
            const value = object[key]?.value ?? null;
            if (keysSelect.includes(key)) return JSON.stringify(value);
            return null;
        });
        const combinedString = filteredValues.join("|");
        return crypto.subtle.digest("SHA-256", new TextEncoder().encode(combinedString)).then((buffer) => {
            return Array.from(new Uint8Array(buffer))
                .map((b) => b.toString(16).padStart(2, "0"))
                .join("");
        });
    }
}
export default getHashFromObject;
